import {BoxIcon, Grid, Typography, UnstableCard as Paper} from '@yandex-delivery/blocks'
import React from 'react'

import {Body, Header, PhoneInput} from 'src/shared/components/desktop'
import {i18n} from 'src/shared/config'
import {orderPath} from 'src/shared/utils'

import {PointDropOff} from '../../PointDropOff/PointDropOff'

export function SourcePointNdd(): React.ReactElement {
  return (
    <Paper radius="L">
      <Grid data-e2e="source-point" size="m" container>
        <Grid xs={12} item>
          <Header lead={<BoxIcon />}>{i18n('cargo.create.form.from', 'Откуда')}</Header>
        </Grid>
        <PointDropOff name={orderPath('sourcePoint.dropOffPoint')} />
        <Grid xs={12} item>
          <Body
            lead={
              <Typography group="tight" mt="m" thickness="medium" variant="body2">
                {i18n('cargo.create.form.source', 'Отправитель')}
              </Typography>
            }
            tail={
              <PhoneInput data-testid="ndd.sourcePoint_contact_phone" name={orderPath('sourcePoint.contact.phone')} />
            }
          />
        </Grid>
      </Grid>
    </Paper>
  )
}
